<template>
    <slot></slot>
</template>

<style src="./DatePicker.scss"></style>
<script src="./DatePicker"></script>
